import React from 'react';
import { Tooltip } from '@material-ui/core';
import { PlayerInfoProps } from '@screens/players/types/player.info.props';
import { InfoArea, InfoAreaTitle } from '@screens/players/player.details.tabs/player.info.styles';
import { StatsContainer } from '@screens/players/stats.container';
import { StatDisplay, StatRow } from '@screens/players/stat.display';
import dogColorImg from '@assets/rex/items/dog_color_base.png';
import dogColors from '@assets/rex/items/dog.colors';
import dogCollars from '@assets/rex/items/dog.collars';
import dogHats from '@assets/rex/items/dog.hats';
import dogClothes from '@assets/rex/items/dog.clothes';
import { DogColorBase, ItemImg } from '@screens/players/player.details.tabs/info/dog.cosmetics.info.styles';

export const DogCosmeticsInfo = ({ info }: PlayerInfoProps) => {
  const cosmetics = info.detailCosmetics;
  if (!cosmetics) return null;

  const colorInfo = dogColors[cosmetics.color];
  const collarInfo = dogCollars[cosmetics.collar];
  const hatInfo = dogHats[cosmetics.hat];
  const clothInfo = dogClothes[cosmetics.cloth];

  return (
    <InfoArea>
      <InfoAreaTitle>Dog/Cosmetics Info</InfoAreaTitle>
      <StatsContainer outlined column expandHeight>
        <StatRow label='Dog name'>{cosmetics.dogName}</StatRow>

        <StatsContainer subContainer>
          {colorInfo && (
            <StatDisplay label='Color'>
              <Tooltip title={colorInfo.name}>
                <DogColorBase $color={colorInfo.colorHex}>
                  <ItemImg src={dogColorImg} alt={colorInfo.name} />
                </DogColorBase>
              </Tooltip>
            </StatDisplay>
          )}

          {collarInfo && (
            <StatDisplay label='Collar'>
              <Tooltip title={collarInfo.name}>
                <ItemImg src={collarInfo.image} alt={collarInfo.name} />
              </Tooltip>
            </StatDisplay>
          )}

          {hatInfo && (
            <StatDisplay label='Hat'>
              <Tooltip title={hatInfo.name}>
                <ItemImg src={hatInfo.image} alt={hatInfo.name} />
              </Tooltip>
            </StatDisplay>
          )}

          {clothInfo && (
            <StatDisplay label='Cloth'>
              <Tooltip title={clothInfo.name}>
                <ItemImg src={clothInfo.image} alt={clothInfo.name} />
              </Tooltip>
            </StatDisplay>
          )}
        </StatsContainer>
      </StatsContainer>
    </InfoArea>
  );
};
